import React, { Component } from "react";
import { Col, Row } from "react-flexbox-grid";
import { Card, BarChart, Loader } from "ui-kit-ck-consultant";

import axiosConfig from "../../../utils/axiosConfig";
import WidgetWrapper from "./WidgetWrapper";
import PerimeterBadge from "../PerimeterBadge";
import { getPercentageValue, getValue } from "../../../utils/general";

const formatRate = (value) =>
  value === null || value === undefined ? "—" : getPercentageValue(value);

const colorForRate = (rate, goodThreshold, warnThreshold) => {
  if (rate === null || rate === undefined) return "#9aa5b1";
  if (rate >= goodThreshold) return "#1e8e3e";
  if (rate >= warnThreshold) return "#f5a623";
  return "#d93025";
};

class RateCard extends Component {
  render() {
    const {
      title,
      year,
      rate,
      labels,
      byMonth,
      cumul,
      goodThreshold,
      warnThreshold,
      sampleLabel,
      sampleCount,
      onClick,
      perimeter,
      group,
    } = this.props;

    const color = colorForRate(rate, goodThreshold, warnThreshold);
    const hasData =
      Array.isArray(byMonth) && byMonth.some((v) => v !== null && v > 0);

    // Comparison vs group/cabinet ref (higher is better for both PRE and target pieces)
    const groupYear = group && group.year != null ? group.year : null;
    const groupCumul = group && Array.isArray(group.cumul) ? group.cumul : null;
    const delta =
      rate != null && groupYear != null
        ? +(rate - groupYear).toFixed(2)
        : null;
    const deltaColor =
      delta == null
        ? "#9aa5b1"
        : delta > 0
        ? "#1e8e3e"
        : delta < 0
        ? "#d93025"
        : "#6b7280";
    const deltaSign = delta == null ? "" : delta > 0 ? "+" : "";

    return (
      <Card
        className="mb-10"
        title={title}
        action={
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "12px",
              color: "#6b7280",
              fontWeight: 500,
            }}
          >
            <span>{year}</span>
            {perimeter && <PerimeterBadge perimeter={perimeter} compact />}
          </span>
        }
      >
        <div
          onClick={onClick}
          style={{
            cursor: onClick ? "pointer" : "default",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              gap: "12px",
              marginBottom: "4px",
            }}
          >
            <span
              style={{
                fontSize: "36px",
                fontWeight: 700,
                lineHeight: 1,
                color,
              }}
            >
              {formatRate(rate)}
            </span>
          </div>
          <div
            style={{
              fontSize: "12px",
              color: "#6b7280",
              marginBottom: "8px",
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <span>
              {sampleLabel} :{" "}
              <strong>
                {sampleCount > 0 ? sampleCount.toLocaleString("fr-FR") : "—"}
              </strong>
            </span>
            {groupYear != null && (
              <span
                title="Comparaison vs groupe"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                Groupe : <strong>{formatRate(groupYear)}</strong>
                {delta != null && (
                  <span
                    style={{
                      color: deltaColor,
                      fontWeight: 600,
                      fontSize: "11px",
                      padding: "1px 6px",
                      borderRadius: "10px",
                      backgroundColor: `${deltaColor}14`,
                    }}
                  >
                    {deltaSign}
                    {getValue(delta)} pt
                  </span>
                )}
              </span>
            )}
          </div>

          <div
            style={{
              height: "6px",
              background: "#eef0f3",
              borderRadius: "3px",
              overflow: "hidden",
              marginBottom: "4px",
              position: "relative",
            }}
          >
            <div
              style={{
                width: `${Math.min(Math.max(rate || 0, 0), 100)}%`,
                background: color,
                height: "100%",
                transition: "width 0.4s",
              }}
            />
            {groupYear != null && (
              <div
                title={`Groupe : ${formatRate(groupYear)}`}
                style={{
                  position: "absolute",
                  top: "-2px",
                  bottom: "-2px",
                  left: `${Math.min(Math.max(groupYear, 0), 100)}%`,
                  width: "2px",
                  background: "#1f2937",
                }}
              />
            )}
          </div>
          <div
            style={{
              fontSize: "10px",
              color: "#9aa5b1",
              marginBottom: "8px",
            }}
          >
            {groupYear != null
              ? "Trait noir = moyenne Groupe"
              : " "}
          </div>

          <div
            style={{
              height: "140px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "auto",
            }}
          >
            {hasData ? (
              <div style={{ width: "100%", height: "100%" }}>
                <BarChart
                  format="percentage"
                  labels={labels}
                  widthBar={20}
                  height={140}
                  dataSet={[
                    ...(groupCumul
                      ? [
                          {
                            label: "Groupe (cumul)",
                            type: "line",
                            data: groupCumul,
                            color: "#9ca3af",
                            yAxisID: "B",
                            borderDash: [4, 4],
                          },
                        ]
                      : []),
                    {
                      label: "Moyenne cumulée",
                      type: "line",
                      data: cumul,
                      color: "#1f2937",
                      yAxisID: "B",
                    },
                    {
                      label: "Mensuel",
                      type: "bar",
                      data: byMonth,
                      color,
                      yAxisID: "B",
                    },
                  ]}
                  yAxes={[
                    {
                      id: "B",
                      ticks: {
                        display: false,
                        beginAtZero: true,
                      },
                    },
                  ]}
                />
              </div>
            ) : (
              <p
                style={{
                  textAlign: "center",
                  color: "#9aa5b1",
                  fontSize: "12px",
                  margin: 0,
                }}
              >
                Aucune donnée sur les 6 derniers mois
              </p>
            )}
          </div>
        </div>
      </Card>
    );
  }
}

export default class WidgetRepairRates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
      data: null,
    };
  }

  componentDidMount() {
    axiosConfig("home/get-target-rates")
      .then((res) => {
        if (res.data.success && res.data.data) {
          this.setState({ data: res.data.data, isLoad: false });
        } else {
          this.setState({ isLoad: false });
        }
      })
      .catch(() => {
        this.setState({ isLoad: false });
      });
  }

  redirect = () => {
    document.location.href = "/global-performance";
  };

  render() {
    const { isLoad, data } = this.state;
    const year = new Date().getFullYear();

    if (isLoad) {
      return (
        <WidgetWrapper
          title="Indicateurs de réparation"
          noCard
          isCustomizing={this.props.isCustomizing}
          dragHandleProps={this.props.dragHandleProps}
          onHide={this.props.onHide}
        >
          <Loader />
        </WidgetWrapper>
      );
    }

    if (!data) {
      return (
        <WidgetWrapper
          title="Indicateurs de réparation"
          noCard
          isCustomizing={this.props.isCustomizing}
          dragHandleProps={this.props.dragHandleProps}
          onHide={this.props.onHide}
        >
          <p
            className="mt-10 mb-10"
            style={{ textAlign: "center", color: "#999" }}
          >
            Aucune donnée disponible
          </p>
        </WidgetWrapper>
      );
    }

    return (
      <WidgetWrapper
        title="Indicateurs de réparation"
        noCard
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        <Row>
          <Col xs={12} md={6}>
            <RateCard
              title="Taux de réparation des pièces cibles"
              year={year}
              rate={data.targetPieces.year}
              labels={data.labels}
              byMonth={data.targetPieces.byMonth}
              cumul={data.targetPieces.cumul}
              goodThreshold={50}
              warnThreshold={35}
              sampleLabel="Pièces cibles analysées"
              sampleCount={data.targetPieces.totalPieces}
              onClick={this.redirect}
              perimeter={this.props.perimeter}
              group={data.targetPieces.group}
            />
          </Col>
          <Col xs={12} md={6}>
            <RateCard
              title="Taux de PRE"
              year={year}
              rate={data.PRE.year}
              labels={data.labels}
              byMonth={data.PRE.byMonth}
              cumul={data.PRE.cumul}
              goodThreshold={25}
              warnThreshold={15}
              sampleLabel="Dossiers réparables clos"
              sampleCount={data.PRE.totalClosingR}
              onClick={this.redirect}
              perimeter={this.props.perimeter}
              group={data.PRE.group}
            />
          </Col>
        </Row>
      </WidgetWrapper>
    );
  }
}
